import * as actions from './actions'
import * as mutations from './mutations'
import * as getters from './getters'

export const createInitialState = () => ({
  companyDetails: {
    name: null,
    address: null,
    contact: null
  },
  isSending: false
})

export default {
  state: createInitialState(),
  mutations,
  actions,
  getters
}
